import React, { useEffect, useState } from "react";
import { postCirugiaEspecialidad } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import TablaModificarListaSeleccionEspecialidad from "./TablaModificarListaSeleccionEspecialidad";

const ModalModificarListaSeleccionEspecialidad = ({setmodalOnModificarEspecialidad, passChildModificarEspecialidad, dataChildModificarMedico}) => {
    const [dataEspecialidad, setDataEspecialidad] = useState([])
    const [loading,setLoading]=useState(true)
    const handleCancelarClick=()=>{
        setmodalOnModificarEspecialidad(false)
    }

    const passModificarEspecialidad=(data)=>{
      passChildModificarEspecialidad(data)
      setmodalOnModificarEspecialidad(false)
    }

    useEffect(()=>{
      //console.log(dataChildModificarMedico.length,'dataChildModificarMedico')
        const body = {
            //varMMCODM: dataChildReservadoPorEspecialidad.codigoEspecialidad,
            varMMCODM: dataChildModificarMedico,
            varEspEst: 'S',
            varMEEstE: 'S',
            varMENomE: ''
          }
          if(dataChildModificarMedico != '     '){
            postCirugiaEspecialidad(body).then((res)=>{
              //console.log(res.data,"ESPECX")
              setLoading(true)
              setDataEspecialidad(res.data)
            })
          }
          
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            >
              Lista de Selección de Especialidades
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
          <form >
              <div className="flex py-1 text-left">
                <div className="w-1/4  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Código Médico
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      defaultValue={dataChildModificarMedico}
                      type="number"
                      name="codigoMedico"
                      autoComplete="off"
                      disabled={true}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                {/* <div className="w-1/4  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Código Especialidad
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      name="codigoEspecialidad"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label className="px-2"></label>
                    
                  </div>
                </div> */}
                {/* <div className="w-2/4  ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      name="descripcion"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <button
                      type="submit"
                      className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button>
                  </div>
                </div> */}
              </div>
              
            </form>

            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-1 inline-block min-w-full sm:px-1 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Código Especialidad
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Descripción Especialidad
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading?
                      dataEspecialidad.map((item,index)=>(
                        <TablaModificarListaSeleccionEspecialidad key={index} item={item} passModificarEspecialidad={passModificarEspecialidad}/>
                      ))
                      :
                      <tr>
                        <td></td>
                        <td className='text-right'><Loading/></td>
                      </tr>
                    }                      
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            {/* <button type="button"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalModificarListaSeleccionEspecialidad